import 'modernizr'; // eslint-disable-line
import porta from 'porta';
import nl from 'porta/src/i18n/nl';
import en from 'porta/src/i18n/en';
import '../vendor/bootstrap';

import tracking from '../modules/tracking';
import toTop from '../modules/toTop';
import videoOverlay from '../modules/videoOverlay';
import videoElement from '../modules/videoElement';
import slider from '../modules/slider';
import toggle from '../modules/toggle';
import jumpToElement from '../modules/jumpToElement';
import datepicker from '../modules/datepicker';
import cookieBar from '../modules/cookieBar';
import popup from '../modules/popup';
import embedWrap from '../modules/embedWrap';
import whatsapp from '../modules/whatsapp';
import alert from '../modules/alert';
import accessibility from '../modules/accessibility';
import mediaRow from '../modules/mediaRow';
import controlledInput from '../modules/controlledInput';
import reviewsBar from '../modules/reviewsBar';
import product from '../modules/product';
import productSliderThumbnails from '../modules/productSliderThumbnails';
import tabs from '../modules/tabs';
import accountGiftSlider from '../modules/accountGiftSlider';
import recentOrderSlider from '../modules/recentOrderSlider';
import giftModal from '../modules/giftModal';
import categories from '../modules/categories';
import sample from '../modules/sample';
import deliveryMoment from '../modules/deliveryMoment';
import inViewport from '../helpers/inViewport';
import autoOpenModal from '../modules/autoOpenModal';

const general = () => {
  tracking.initialize();
  accessibility.initialize();
  toTop.initialize();
  videoOverlay.initialize();
  videoElement.initialize();
  slider.initialize();
  toggle.initialize();
  jumpToElement.initialize();
  datepicker.initialize();
  cookieBar.initialize();
  popup.initialize();
  embedWrap();
  whatsapp.initialize();
  alert.initialize();
  mediaRow.initialize();
  controlledInput.initialize();
  reviewsBar.initialize();
  product.initialize();
  productSliderThumbnails.initialize();
  tabs.initialize();
  accountGiftSlider.initialize();
  giftModal.initialize();
  categories.initialize();
  sample.initialize();
  deliveryMoment.initialize();
  recentOrderSlider.initialize();
  autoOpenModal.initialize();

  $('[data-toggle="tooltip"]').tooltip();

  if ($('.modal.auto-open').length && !$('.modal.auto-open').hasClass('ab-test')) {
    $('.modal.auto-open').modal('show');
  }

  porta({
    messages: window.app.i18n.isOrderForm === '1' ? en : nl,
    onError: (formElement) => {
      const firstError = formElement.querySelector('.porta-error');
      const errorOutput = formElement.querySelector('.js-porta-error-ouput');

      if (errorOutput && !inViewport(firstError)) {
        errorOutput.style.display = 'block';
        errorOutput.setAttribute('data-jump-target', `#${firstError.id}`);
      }
    },
  });
};

export default general;
